import 'react-app-polyfill/ie11';
import React from 'react';
import './myutils';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { resolveBrowserLocale } from 'react-admin';

ReactDOM.render(<div id='App' 
                dir={(sessionStorage.getItem("dir")!==null)?
                    (sessionStorage.dir):(resolveBrowserLocale()==='he')?
                    ('rtl') : ('ltr')} 
                    onMouseMove={()=>{(sessionStorage.getItem("dir")!==null)?
                    (document.getElementById("App").dir = sessionStorage.dir):(resolveBrowserLocale()==='he')?
                    (document.getElementById("App").dir = 'rtl') : (document.getElementById("App").dir = 'ltr')}} 
                onClick={()=>{(sessionStorage.getItem("dir")!==null)?
                    (document.getElementById("App").dir = sessionStorage.dir):(resolveBrowserLocale()==='he')?
                    (document.getElementById("App").dir = 'rtl') : (document.getElementById("App").dir = 'ltr')}} >
                <App />
                </div>, document.getElementById('root'));